export default "__VITE_ASSET__0cce7356__"